// extracted by mini-css-extract-plugin
export default {"icon":"Details_icon__qJ+ZI","container":"Details_container__xFUjX","coin":"Details_coin__siEek","name":"Details_name__bDzLd","span":"Details_span__EGwZj"};